import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  Model
} from "@ofqual/portal-core/core/types";

export class RecognitionQualTypeService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/qualificationtypes?recognitionQualTypesOnly=true`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.description, active: item.active }));
  }
}

export class CountryService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/countries?portalOnly=true`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.description, active: item.active }));
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/countries/${id}`;
    return await super.getRequest<Model>(url, opts);
  }
}

export class TitlesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/titles`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.description, active: item.active }));
  }
}

export class LegalEntityTypesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/legalentitytypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/legalentitytypes/${id}`;
    return await super.getRequest<Model>(url, opts);
  }
}

export class RoEPAOsPresenceOptionsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/roepaospresenceoptions`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class EngagementPerceivedUnderstandingOptionsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/engagementperceivedunderstandingoptions`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.code, active: item.active }));
  }
}

export class EngagementCloseReasonsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/engagementclosereasons`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class EngagementEventTypesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/engagementeventtypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class EngagementEventMeansOfCommunicationTypesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/engagementeventmeansofcommunicationtypes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class RecognitionReviewOutcomesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/recognitionreviewoutcomes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class RecognitionApplicationReviewOutcomesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/recognitionapplicationreviewoutcomes`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class RecognitionPanelDecisionsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/recognitionpaneldecisions`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.value, active: item.active }));
  }
}

export class RecognitionRejectReasonsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/recognitionrejectreasons`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map(item => ({ id: item.id, label: item.code, active: item.active }));
  }
}
